<template>
  <v-container class="Profil">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <v-toolbar class="my-md-auto " elevation="0" rounded="lg">
      <v-toolbar-title  class="hidden-md-and-down">
          <h2 v-if="this.user"><v-icon large class="mr-2">mdi-tooltip-account</v-icon>{{ this.user.login }}</h2>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-btn
          class="ml-2"
          color="primary"
          @click="cancel"
        >
          {{ $t('global.cancel')}}
        </v-btn>
        <v-btn
          class="ml-2"
          color="primary"
          @click="updateProfil"
        >
          {{ $t('global.update')}}
        </v-btn>
      </div>
    </v-toolbar>

    <div>
      <v-container>
        <v-row>
          <v-col md="12">
            <UpdateProfilForm class="ml-2" ref="UpdateProfilForm" :values="item" :errors="violations" />
          </v-col>
        </v-row>
        <Loading :visible="isLoading" />
      </v-container>
    </div>
    </v-sheet>

  </v-container>
</template>

<script>
  import { createHelpers } from 'vuex-map-fields';
import { mapActions, mapState,mapGetters } from 'vuex';
import UpdateProfilForm from '../../components/profil/Form.vue';
import Loading from '../../components/Loading';
import NotificationMixin from '../../mixins/NotificationMixin';

const servicePrefix = 'User';
const { mapFields } = createHelpers({
  getterType: 'user/getField',
  mutationType: 'user/updateField'
});

export default {
  name: 'UpdateProfil',
  servicePrefix,
  mixins: [NotificationMixin],
  components: {
    Loading,
    UpdateProfilForm
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations']),
    ...mapState('user', {
      actioned: 'actioned',
      updatedata: 'updatedata',
      action: 'action',
      error: 'error',
      isLoading: 'isLoading',
    }),
    ...mapGetters('user',{
      dataUser: 'data',
    }),
    user: {
      get() { return this.item },
      set(value) { this.item = value; }
    }
  },
  data() {
    return {
      item: {}
    };
  },
  methods: {
    ...mapActions({
      userPushAction: 'user/action',
      userGetData: 'user/data'
    }),
    cancel() {
      this.$refs.UpdateProfilForm.$v.$reset();
      this.$router.push({ name: `Profil` });
    },
    updateProfil() {
      const UpdateProfilForm = this.$refs.UpdateProfilForm;
      UpdateProfilForm.$v.$touch();
      if (!UpdateProfilForm.$v.$invalid) {
        this.userPushAction({action: 'edit/profil',values: {'firstname' :UpdateProfilForm.$v.item.$model.firstname, 'lastname' : UpdateProfilForm.$v.item.$model.lastname , 'email' : UpdateProfilForm.$v.item.$model.email}});
      } else {
        console.log('error');
      }
    },
    updatedProfil(item) {
      console.log("updated");
      this.$router.push({ name: `Profil` });
      this.showMessage(item.message);
    },

  },
  mounted() {
    if (! this.dataUser('profil')) {
      this.userGetData({data: 'profil'});
    } else {
      this.user = this.dataUser('profil');
    }
 },
  watch: {
    actioned(actioned) {
      if (!actioned) {
        return;
      }
      if (this.action == 'edit/profil') {
        this.updatedProfil(actioned);
      }
    },
    updatedata: function (updatedata) {
      console.log('updatedata');
      if (updatedata == 'profil') {
        this.user = this.dataUser('profil');
      }
    },
    error(message) {
      message && this.showError(message);
    }
  }
};
</script>
